import { Dtos, pluralize, SuretyAccountId } from "@inrev/common";
import { Modal } from "@portal/components/layout/Modal";
import { ModalItemWithHeader } from "@portal/components/layout/ModalItemWithHeader";
import { AccountCompanyCard } from "./AccountCompanyCard";

type AccountCompaniesModalProps = {
	accountId: SuretyAccountId;
	companies: (Dtos.Company.Get.Response | Dtos.Admin.SuretyAccount.Get.Response.Company)[];
	onClose: () => void;
	options: {
		showPrequalButton: boolean;
		enablePrequalButton: boolean;
	};
};

export const AccountCompaniesModal = ({
	accountId,
	companies,
	onClose,
	options,
}: AccountCompaniesModalProps) => {
	return (
		<Modal onClickOutside={onClose}>
			<ModalItemWithHeader
				header={pluralize(companies.length, "Company", "Companies")}
				onClose={onClose}
				className="h-full max-h-[70vh]"
				bodyClassName="overflow-y-auto"
			>
				<div className="w-full h-full overflow-y-auto">
					<div className="flex flex-col w-[600px] min-w-[600px]">
						{companies.map((company) => (
							<AccountCompanyCard accountId={accountId} company={company} options={options} />
						))}
					</div>
				</div>
			</ModalItemWithHeader>
		</Modal>
	);
};
